import { render } from "./service_rules.html?vue&type=template&id=1467cd19&external"
import script from "./service_rules.js?vue&type=script&lang=js&external"
export * from "./service_rules.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__